import { CircleTickIcon } from '@components';
import { Features, PlanInfos } from '@containers/Pricing/constants/Comparisons';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import Image from 'next/image';
import React from 'react';
import styles from './styles.module.scss';

const ComparisonTable = () => (
  <div className={styles.gridContainer}>
    {/* <!-- Header Row --> */}
    <div className={styles.header} />
    {PlanInfos.map((plan) => (
      <div
        key={plan.name}
        className={classNames(styles.header, {
          [styles.popular]: plan.name === 'Standard',
        })}
      >
        <Image src={plan.icon} alt={`${plan.name} icon`} className={styles.image} />
        <div>{plan.name}</div>
      </div>
    ))}

    {/* <!-- Feature Rows --> */}
    {Features.map((feature, featureIndex) => (
      <React.Fragment key={feature.name}>
        <div className={classNames(styles.featureRow, styles.featureColumn)}>
          <span>{feature.name}</span>
          {/* TODO: hide icon temporarily */}
          {/* {feature.hasDescription && (
            <Tooltip title={<h1>Test</h1>} enterTouchDelay={0}>
              <div className={styles.questionIconContainer}>
                <CircleQuestionIcon className={styles.questionIcon} fill="#0a1e55" />
              </div>
            </Tooltip>
          )} */}
        </div>
        {feature.plans.map((plan, planIndex) =>
          (() => {
            switch (plan) {
              case '':
                return (
                  <div
                    key={nanoid()}
                    className={classNames(styles.featureRow, {
                      [styles.popular]: planIndex === 1,
                      [styles.popularLastRow]:
                        featureIndex === Features.length - 1 && planIndex === 1,
                    })}
                  />
                );
              case 'custom':
                return (
                  <div
                    key={nanoid()}
                    className={classNames(styles.featureRow, styles.customColumn)}
                  >
                    Custom
                  </div>
                );
              default:
                return (
                  <div
                    key={nanoid()}
                    className={classNames(styles.featureRow, {
                      [styles.popular]: planIndex === 1,
                    })}
                  >
                    <CircleTickIcon className={styles.tickIcon} />
                  </div>
                );
            }
          })(),
        )}
      </React.Fragment>
    ))}
  </div>
);

export default ComparisonTable;
